module.exports = __webpack_public_path__ + "static/img/eri-mudkip.d262bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/eri-mudkip.jpg
// module id = Dfb6
// module chunks = 1